export default __webpack_public_path__ + "static/media/card-image.c30937ba.png";